import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, ExternalLink } from 'lucide-react';
import Scanlines from '../components/Scanlines';
import { streamingLinks, albumData } from '../mock';

const Listen = () => {
  const navigate = useNavigate();

  return (
    <div className="page-container">
      <Scanlines />
      
      <button onClick={() => navigate('/')} className="back-button">
        <ArrowLeft size={20} />
        <span>BACK</span>
      </button>

      <div className="page-content listen-content">
        <h1 className="page-title-simple">LISTEN NOW</h1>
        
        <div className="listen-album-info">
          <img 
            src={albumData.image} 
            alt={albumData.title}
            className="listen-album-image"
          />
          <h2 className="listen-album-title">{albumData.title}</h2>
        </div>

        <div className="streaming-links">
          {streamingLinks.map((platform, index) => (
            <a
              key={index}
              href={platform.url}
              target="_blank"
              rel="noopener noreferrer"
              className="streaming-link"
            >
              <span className="streaming-name">{platform.name}</span>
              <ExternalLink size={18} />
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Listen;
